module.exports = __webpack_public_path__ + "img/LI.3719ea6d.svg";